export const SET_CUSTOMER = "SET_CUSTOMER";
export const SET_NAME = "SET_NAME";
export const SET_CELL_PHONE = "SET_CELL_PHONE";
export const SET_TITLE = "SET_TITLE";
export const SET_COUNTRY_CODE = "SET_COUNTRY_CODE";
